module.exports = __webpack_public_path__ + "static/media/faildImg.cfa1cf5c.png";